import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { TemplatesComponent } from './templates.component'
import { CreateTemplateComponent } from './create-template/create-template.component'
import { UpdateTemplateComponent } from './update-template/update-template.component'
import { templatesRoutes } from './templates.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '../../shared/shared.module'
import { TemplateTagsModule } from '@components/template-tags/template-tags.module'
import { TestTemplateModule } from '@components/test-template/test-template.module'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [
    TemplatesComponent,
    CreateTemplateComponent,
    UpdateTemplateComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(templatesRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    TemplateTagsModule,
    TestTemplateModule,
    BreadcrumbsModule,
  ],
  exports: [
    TemplatesComponent,
    CreateTemplateComponent,
    UpdateTemplateComponent,
  ],
})
export class TemplatesModule {}
